export default __webpack_public_path__ + "static/media/keyboard.8d45c5b8.svg";